module.exports = __webpack_public_path__ + "img/back_main.c12d9798.png";